<script>
import BaseFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';
import { DevicesService } from '@/services/devices.service';

export default {
  name: 'LastNameFilter',

  extends: BaseFilter,

  data() {
    return {
      name: 'last_name'
    };
  },

  methods: {
    getData() {
      return DevicesService.getFilteredLastNames({ search: this.search })
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
